<template>
  <ion-page>
    <ion-header class="privacy-header">
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-button @click="$router.back()">
            <ion-icon :icon="arrowBackOutline"></ion-icon>
          </ion-button>
        </ion-buttons>
        <ion-title>Политика конфиденциальности</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="main-background privacy-content" :fullscreen="true">
      <div class="privacy-body ion-padding">
        <p class="privacy-intro">
          Настоящая Политика конфиденциальности приложения «Лига тренеров» (далее — Приложение) определяет порядок обработки персональных данных пользователей и действует в отношении всех данных, которые Национальная лига тренеров (далее — Оператор) может получить о пользователе во время использования Приложения.
        </p>

        <h2>1. Общие положения</h2>
        <p>
          Использование Приложения означает согласие пользователя с настоящей Политикой конфиденциальности и условиями обработки персональных данных. В случае несогласия с условиями пользователь должен воздержаться от использования Приложения.
        </p>
        <p>
          Оператор обеспечивает конфиденциальность персональных данных и принимает необходимые меры для их защиты в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных».
        </p>

        <h2>2. Персональные данные</h2>
        <p>
          Приложение может собирать и обрабатывать следующие данные: имя, фамилия, адрес электронной почты, логин и пароль (в зашифрованном виде), данные об использовании разделов Приложения (образование, тестирование, тренировки), технические данные устройства (тип ОС, версия приложения) для обеспечения работоспособности и улучшения сервиса.
        </p>

        <h2>3. Цели обработки</h2>
        <p>
          Персональные данные используются для предоставления доступа к материалам и услугам Приложения, идентификации пользователя, связи с пользователем, улучшения работы Приложения и исполнения договора оферты.
        </p>

        <h2>4. Защита данных</h2>
        <p>
          Оператор принимает организационные и технические меры для защиты персональных данных от неправомерного доступа, уничтожения, изменения, блокирования, копирования и распространения.
        </p>

        <h2>5. Права пользователя</h2>
        <p>
          Пользователь вправе запросить доступ к своим персональным данным, их уточнение, блокирование или удаление, направив запрос на контактный e-mail Оператора. Удаление аккаунта доступно в разделе «Личный кабинет» Приложения.
        </p>

        <h2>6. Договор оферты</h2>
        <p>
          Использование Приложения и оказание услуг регулируются также условиями публичной оферты. С полным текстом договора оферты можно ознакомиться по ссылке:
        </p>
        <a :href="offerUrl" target="_blank" rel="noopener noreferrer" class="privacy-link">{{ offerUrl }}</a>
        <p>
          Дополнение к оферте (платные события) доступно в приложении:
        </p>
        <router-link to="/offer-supplement" class="privacy-link">Дополнение к оферте — платные события</router-link>

        <h2>7. Изменения</h2>
        <p>
          Оператор вправе вносить изменения в настоящую Политику конфиденциальности. Актуальная версия всегда доступна в Приложении. Продолжение использования Приложения после публикации изменений означает принятие обновлённой Политики.
        </p>

        <p class="privacy-footer">
          © Национальная лига тренеров
        </p>
      </div>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonPage,
  IonTitle,
  IonToolbar,
} from '@ionic/vue';
import { arrowBackOutline } from 'ionicons/icons';
import { defineComponent } from 'vue';

const OFFER_URL = 'https://ligatrenerov.ru/agreement';

export default defineComponent({
  name: 'PrivacyPolicy',
  components: {
    IonButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonIcon,
    IonPage,
    IonTitle,
    IonToolbar,
  },
  setup() {
    return {
      arrowBackOutline,
      offerUrl: OFFER_URL,
    };
  },
});
</script>

<style scoped>
.privacy-header ion-toolbar {
  --background: var(--ion-color-dark);
  --color: #fff;
}
.privacy-header ion-title {
  color: #fff;
}
.privacy-header ion-button,
.privacy-header ion-icon {
  --color: var(--ion-color-orange);
  color: var(--ion-color-orange);
}

.privacy-content {
  --background: var(--ion-background-color);
}
.privacy-body {
  max-width: 720px;
  margin: 0 auto;
  color: var(--ion-text-color);
  line-height: 1.6;
}
.privacy-intro {
  font-weight: 500;
  margin-bottom: 1.2em;
}
.privacy-body h2 {
  font-size: 1.1rem;
  margin-top: 1.5em;
  margin-bottom: 0.5em;
  color: var(--ion-color-orange);
}
.privacy-body p {
  margin-bottom: 0.8em;
}
.privacy-link {
  display: inline-block;
  color: var(--ion-color-orange);
  word-break: break-all;
  margin: 0.5em 0 1em;
}
.privacy-footer {
  margin-top: 2em;
  opacity: 0.85;
  font-size: 0.95rem;
}
</style>
